import { createAction } from '@ngrx/store';

export const StartLoading = createAction('[Counter Component] StartLoading');
export const StopLoading = createAction('[Counter Component] StopLoading');
export const Reset = createAction('[Counter Component] Reset');
